import { StoreObject } from '@apollo/client';

import { cacheKeyFromArray } from './utils';

/**
 * The `keyFields` property can be used to specify which field is to be used for generating the
 * primary cache key for a type. See docs: https://www.apollographql.com/docs/react/caching/cache-configuration/#customizing-identifier-generation-by-type
 *
 * The `fields` key in each typePolicy points to either a FieldPolicy or a FieldReadFunction. Here,
 * we are using a FieldPolicy with the shorthand `.merge: true` configuration to merge new values
 * with old ones for these fields. See docs: https://www.apollographql.com/docs/react/caching/cache-field-behavior/
 */
export const typePolicies = {
    UIState: {
        fields: {
            activeLogPolls: {
                merge: true,
            },
            entities: {
                merge: true,
            },
            statements: {
                merge: true,
            },
            tracks: {
                merge: true,
            },
        },
    },
    PROTrack: {
        keyFields: (track: Readonly<StoreObject>): string =>
            cacheKeyFromArray('PROTrack', (track?.work_ids ?? []) as string[]),
    },
    bmatDetection: {
        keyFields: ['detection_id'],
    },
};
